module.exports = __webpack_public_path__ + "static/img/jd1.5122904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd1.jpg
// module id = phAq
// module chunks = 1